import React from 'react';
import { classes } from './ClickableCard.classes';
import { ClickableCardProps } from './ClickableCard.types';
import { DATA_HOOKS, SKIN } from './ClickableCard.constants';
import Action from './components/Action/Action';

const ClickableCard = <T extends 'button' | 'a' = 'button'>(
  props: ClickableCardProps<T>,
) => {
  const {
    as: Component = 'button',
    children,
    dataHook,
    disabled = false,
    hasPadding = true,
    skin = SKIN.standard,
    ...rest
  } = props;

  const commonClickableOverlayProps = {
    className: classes.element('clickableOverlay'),
    'data-hook': DATA_HOOKS.clickableOverlay,
    tabIndex: disabled ? -1 : 0,
    'aria-disabled': disabled,
  };

  return (
    <div
      data-hook={dataHook}
      className={classes.root({ skin, hasPadding, disabled })}
    >
      <Component
        {...(Component === 'button' ? { disabled } : {})}
        {...commonClickableOverlayProps}
        // TODO: try to figure out why TS is complaining about the following line
        {...(rest as any)}
      ></Component>

      {children}
    </div>
  );
};

ClickableCard.displayName = 'ClickableCard';

ClickableCard.Action = Action;

export default ClickableCard;
